const RICOS_VERSION = "10.150.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
